import { useMemo } from 'react';
import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material';
import { TitleTypeLabel, TitleVersionChip } from '@/exports/columnCommonComponents';
import { getAllVersionsAsArray, VersionHierarchyInput } from '@/_utils/bulkSearchUtils';

type FeatureProps = {
  featureName: string;
  parentKey: string;
  entityType: string;
  featureChildren: VersionHierarchyInput;
};
const Feature = ({ parentKey, featureName, entityType, featureChildren }: FeatureProps) => {
  const flattenedVersions = useMemo(() => getAllVersionsAsArray(featureChildren), [featureChildren]);

  return (
    <Card key={parentKey} elevation={0}>
      <CardHeader
        title={
          <Grid container alignItems="center">
            <Grid item sx={{ display: 'flex', alignItems: 'center', maxWidth: '70%' }}>
              <Typography variant="body2" sx={{ fontSize: '1.1rem' }}>
                {featureName}
              </Typography>
            </Grid>
            <Grid item sx={{ ml: 1.5 }}>
              <TitleTypeLabel type={entityType} />
            </Grid>
          </Grid>
        }
      />
      <CardContent sx={{ pb: 0, pt: 1 }}>
        <Box>
          {flattenedVersions.map((fc) => {
            return (
              <Grid key={fc.id} container alignItems="center" sx={{ py: 0.5 }}>
                <Grid item flex="auto">
                  <Divider sx={{ borderColor: 'action.selected', borderStyle: 'dashed', mr: 2 }} />
                </Grid>
                <Grid item>
                  <TitleVersionChip version={fc} withTooltip />
                </Grid>
              </Grid>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default Feature;
